import type { IGetMarketsByEventIdRequestParams } from "~/feature/dashboard/types";
import { INITIAL_MARKETS_LIMIT } from "~/feature/event/components/MarketsDataGrid/constants";
import {
  DEFAULT_MARKETS_SORT_PARAMS,
  MARKETS_GROUP_RANK_PARAMS,
} from "~/feature/event/constants";

/**
 * Params of the markets grid's first client query, with no filters applied.
 * `useSeedEventMarkets` uses them as the RTK Query cache key so that query is
 * a hit rather than a second fetch.
 */
export const buildInitialMarketsRequestParams = (
  eventId: string
): IGetMarketsByEventIdRequestParams => ({
  id: eventId,
  all: false,
  page: 1,
  limit: INITIAL_MARKETS_LIMIT,
  ungroup: false,
  ...MARKETS_GROUP_RANK_PARAMS,
  ...DEFAULT_MARKETS_SORT_PARAMS,
});

/**
 * What SSR fetches: the same query, but every market rather than page 1.
 * The event page needs the full list to resolve a `?market=` deep link, and
 * the grid's first page is just the first `INITIAL_MARKETS_LIMIT` of it — so
 * one request serves both, provided the sort matches.
 */
export const buildSsrMarketsRequestParams = (
  eventId: string
): IGetMarketsByEventIdRequestParams => ({
  id: eventId,
  all: true,
  ungroup: false,
  ...MARKETS_GROUP_RANK_PARAMS,
  ...DEFAULT_MARKETS_SORT_PARAMS,
});
